import { render } from "./MenuItem.vue?vue&type=template&id=223f90bb&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=223f90bb&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223f90bb"]])

export default __exports__